import { useState, useEffect } from "react";
import { Card, IconButton, Fade, Box, Typography } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { riskLayersEnum } from "./ClimateIndexConstants";

export const LocationDetailsSidebar = ({ selectedProperties: selectedProp, climateIndex }) => {
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const CurrentClimateIndexComponent = riskLayersEnum()[climateIndex].sidePanelComponent;

  useEffect(() => {
    if (selectedProp) {
      setIsSidebarVisible(true);
    }
  }, [selectedProp]);

  return (
    <>
      <div
        style={{
          zIndex: 3,
          position: "absolute",
          top: 0,
          right: 0,

          height: 90,

          maxWidth: 375,
          width: "100%",

          margin: 20,

          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <IconButton
          sx={{
            right: 20,
            backgroundColor: "rgba(0,0,0,.25)",
            "&:hover": { backgroundColor: "rgba(0,0,0,.35)" },
          }}
          onClick={() => {
            setIsSidebarVisible((oldSidebarVisibilityValue) => !oldSidebarVisibilityValue);
          }}
        >
          {isSidebarVisible ? <ArrowForwardIcon /> : <ArrowBackIcon />}
        </IconButton>
      </div>

      <Fade direction="left" in={isSidebarVisible} mountOnEnter unmountOnExit>
        <Card
          style={{
            zIndex: 1,
            position: "absolute",
            top: 0,
            right: 0,

            maxWidth: 375,
            width: "100%",
            // height: "calc(100% - 40px)",
            height: "fit-content",

            margin: 20,
            boxShadow: "none",
          }}
        >
          {!selectedProp && (
            <Box mt={5} ml={2} mb={5}>
              <Typography variant="body2" gutterBottom>
                There is no data available for non italian regions.
              </Typography>
            </Box>
          )}

          {selectedProp && (
            <CurrentClimateIndexComponent
              selectedProperties={selectedProp}
              setIsSidebarVisible={setIsSidebarVisible}
            ></CurrentClimateIndexComponent>
          )}
        </Card>
      </Fade>
    </>
  );
};
